import { Component, OnInit, OnDestroy, AfterViewChecked } from '@angular/core';
import { TutorialStaticProps } from './turorial-static-props';
import { TutorialHttpLogService } from './tutorial-http.service';
import { TutorialKeepPropService } from './tutorial.service';
declare var $: any;

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss'],
})
export class TutorialComponent implements OnInit, AfterViewChecked {

  public TutorialStaticProps = TutorialStaticProps;

  constructor(
    public keep: TutorialKeepPropService,
  ) { }

  // 別ページから遷移した場合、tutorial.componentは破棄されるが、遷移先に同componentがある場合は、この初期処理が実行される。
  ngOnInit() {
    if (TutorialStaticProps.running) {
      this.keep.renderTutorialArea('immidiately');
      this.keep.observeRenderingStepNo();
    }
  }

  ngAfterViewChecked() {
    // Angularで変更検知が実施される毎に、Subjectに値を流す（＝描写対象要素が画面に存在しているか判定される）
    if (TutorialStaticProps.running &&
        TutorialStaticProps.steps.length >= 1 &&
        TutorialStaticProps.observeStepNoElement$ &&
        !TutorialStaticProps.observeStepNoElement$.closed &&
        TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].targetElementId) {
      TutorialStaticProps.observeStepNoElement$.next($(`${TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].targetElementId}`));
    }
  }
}
